import React from "react";

import styles from "./DirectusHtmlWrapper.module.css";

type Props = {
  content: string;
};

const DirectusHtmlWrapper: React.FC<Props> = ({ content, ...props }) => {
  return (
    <div
      className={styles.directusHtmlWrapper}
      {...props}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default DirectusHtmlWrapper;
